import React, { FC } from "react";
import { Notification, useAppContext } from "@ftdr/blueprint-components-react";
import { ErrorBoundary } from "react-error-boundary";

export const ErrorBoundaryComponent: FC = ({ children }) => {
  const {
    appSettings: { localizedText },
  } = useAppContext();

  return (
    <ErrorBoundary
      FallbackComponent={() => (
        <Notification
          variant="inline"
          status="error"
          size="medium"
          showStatusLabel={true}
          inline={true}
        >
          {localizedText(`CLIENT_TOKEN_ERROR`)}
        </Notification>
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
